import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './icon.js';

const componentHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:var(--jw-theme-surface-level0-bg-color);border-bottom:1px solid var(--jw-theme-surface-border-border-color);box-sizing:border-box;color:var(--jw-theme-surface-text-description-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;font-weight:600;gap:1rem;letter-spacing:-.0004em;line-height:normal;line-height:1.25rem;padding:1rem}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";
const WuiComponentHeaderStyle0 = componentHeaderCss;

const WuiComponentHeader = /*@__PURE__*/ proxyCustomElement(class WuiComponentHeader extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.label = undefined;
        this.icon = undefined;
    }
    render() {
        return (h(Host, { key: 'dc0ecd388eeb631a4624c830260b7e2bad847642' }, this.icon && h("wui-icon", { key: 'f8fdec0db2ee215c533fa8d04bbe1952feb89704', name: this.icon, size: "md" }), this.label && h("span", { key: 'fa5f32744a0c31654dfc7047c78aa0240e7667a1' }, this.label), h("slot", { key: 'cfe7ef3af3fd061d728f7134e5865a1c0fa9006e' })));
    }
    static get style() { return WuiComponentHeaderStyle0; }
}, [1, "wui-component-header", {
        "label": [1],
        "icon": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-component-header", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-component-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiComponentHeader);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiComponentHeader as W, defineCustomElement as d };

//# sourceMappingURL=component-header.js.map